module.exports = __webpack_public_path__ + "tinymce.7262d908f15434ec7c3a.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/assets/skins/lightgray/fonts/tinymce.svg
// module id = ../../../../../src/assets/skins/lightgray/fonts/tinymce.svg
// module chunks = 3